<style scoped lang="scss" type="text/scss">
    $bottom-panel-color: #777;

    .count-down-wrap {
        position: fixed;
        right: .5rem;
        bottom: .5rem;
        z-index: 99;

        .only-icon-container {
            width: 2rem;
            height: 2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: .1rem;
            font-size: 1.2rem;
            color: #888;
            background-color: #FFF;
            box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);;
            transition: transform .2s;

            &:hover {
                cursor: pointer;
                color: #333;
            }
        }

        .count-down-container {
            width: 18rem;
            height: 6rem;
            border-radius: .15rem;
            background-color: #FFF;
            box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);;
            display: flex;

            &:hover {
                cursor: pointer;
            }

            .minimum-button {
                position: absolute;
                font-size: .75rem;
                transform: scale(.7);
                color: #888;
                top: .2rem;
                right: .2rem;
                transition: all .2s;

                &:hover {
                    cursor: pointer;
                    color: #427DFF;
                }
            }

            .left-panel, .right-panel {
                height: 100%;
            }

            .right-panel {
                flex: 1;
                position: relative;

                .top-panel {
                    height: 4rem;
                    box-sizing: border-box;
                    padding-top: .9rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 1.4rem;
                }

                .bottom-panel {
                    text-align: center;
                    font-size: .8rem;
                    color: $bottom-panel-color;
                }

                &:before {
                    content: '';
                    position: absolute;
                    left: -.3rem;
                    top: 20%;
                    width: 1px;
                    height: 60%;
                    background-color: #eee;
                }
            }

            .left-panel {
                width: 5rem;
                position: relative;

                .top-panel {
                    height: 4rem;
                    box-sizing: border-box;
                    padding-top: .5rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 2.8rem;
                }

                .bottom-panel {
                    text-align: center;
                    font-size: .8rem;
                    color: $bottom-panel-color;
                }
            }
        }
    }
</style>

<!--<template>-->
<!--    <div class="count-down-wrap">-->
<!--        <div class="count-down-container" v-if="isMinimum === false">-->
<!--            <div class="left-panel">-->
<!--                <div class="top-panel">-->
<!--                    <svg class="c-icon tip-icon" aria-hidden="true">-->
<!--                        <use xlink:href="#icon-shalou"></use>-->
<!--                    </svg>-->
<!--                </div>-->
<!--                <div class="bottom-panel">-->
<!--                    {{ yearText }}-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="right-panel">-->
<!--                <div class="top-panel">-->
<!--                    {{ differenceText }}-->
<!--                </div>-->
<!--                <div class="bottom-panel">-->
<!--                    中期检查截止：{{ registrationDeadline }}-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="minimum-button" @click="minimize">-->
<!--                <i class="icon">&#xe93e;</i>-->
<!--                <span>最小化</span>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="only-icon-container" @click="maximize" v-else>-->
<!--            <svg class="c-icon tip-icon" aria-hidden="true">-->
<!--                <use xlink:href="#icon-shalou"></use>-->
<!--            </svg>-->
<!--        </div>-->
<!--    </div>-->
<!--</template>-->

<script>
    import _ from 'lodash';
    import {format, differenceTextMDH} from '../../../utils/time';
    import moment from 'moment';

    export default {
        name: '',
        data () {
            return {
                isMinimum: false
            };
        },
        computed: {
            info () {
                return this.$store.state.player.currentMiddlePlayerInfo;
            },
            yearText () {
                const year = _.get(this.info, 'competition.year', '');
                if (year === null) return '';
                return moment(year).year();
            },
            registrationDeadline () {
                const middleCheckDeadline = _.get(this.info, 'competition.middle_check_deadline', null);
                if (middleCheckDeadline === null) return '';
                return format(middleCheckDeadline);
            },
            differenceText () {
                const middleCheckDeadline = _.get(this.info, 'competition.middle_check_deadline', null);
                return differenceTextMDH(Date.now(), middleCheckDeadline);
            }
        },
        methods: {
            minimize () {
                this.isMinimum = true;
            },
            maximize () {
                this.isMinimum = false;
            }
        }
    };
</script>
